






















import { defineComponent, SetupContext, onMounted } from '@vue/composition-api'
import BaseLayout from '@/components/_shared/BaseLayout.vue'
import Modal from '@/components/Modal/Modal.vue'
import Hero from '@/components//Hero/Hero.vue'
import SectionModal from '@/containers/Home/doms/SectionModal.vue'
import SectionMovieList from '@/containers/Home/doms/SectionMovieList.vue'
import { UseStorageComposition } from '@/composition/UseStorageComposition'
import { UseModalComposition } from '@/composition/UseModalComposition'
import { UsePresenterComposition } from '@/composition/UsePresenterComposition'
import { UseHomePresenter, HomePresenter } from '@/containers/Home/UseHomePresenter'

// ================================
// Component
// ================================
export default defineComponent({
  name: 'HomeContainer',
  components: { BaseLayout, Modal, Hero, SectionModal, SectionMovieList },
  setup (props, context: SetupContext) {
    const storage = UseStorageComposition(context)
    const modal = UseModalComposition()
    const presenter = UsePresenterComposition()

    onMounted(async () => {
      const homePresenter = UseHomePresenter(storage.currentStorages(localStorage.getItem('movies')), storage.storageCount())
      await presenter.presenterDatas<HomePresenter>(homePresenter)
      window.scrollTo(0, 0)
    })

    return {
      storage, modal, presenter
    }
  }
})
